/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { TextInput } from '@neo4j-ndl/react';
import { CalendarDaysIconOutline } from '@neo4j-ndl/react/icons';

const Component = () => {
  return (
    <div className="n-flex n-flex-col n-gap-token-16">
      <TextInput
        label="Default loading"
        isLoading
        placeholder="Placeholder"
        htmlAttributes={{ id: 'text-input-loading' }}
      />
      <TextInput
        label="With leading element"
        isLoading
        leadingElement={<CalendarDaysIconOutline />}
        placeholder="Placeholder"
        htmlAttributes={{ id: 'text-input-loading-leading' }}
      />
      <TextInput
        label="With trailing element"
        isLoading
        trailingElement={<CalendarDaysIconOutline />}
        placeholder="Placeholder"
        htmlAttributes={{ id: 'text-input-loading-trailing' }}
      />
      <TextInput
        label="With leading and trailing element"
        isLoading
        leadingElement={<CalendarDaysIconOutline />}
        trailingElement={<CalendarDaysIconOutline />}
        placeholder="Placeholder"
        htmlAttributes={{ id: 'text-input-loading-both' }}
      />
    </div>
  );
};

export default Component;
